export const heroData = {
  tagline: '热门综艺 · 高清不缓冲',
  title: '97在线影院 — 综艺在线观看首选平台',
  slogan: '最新综艺大全，完整版免费看，无需下载',
  description: '97在线影院专注综艺节目在线观看，每日同步更新海内外热门综艺，涵盖真人秀、脱口秀、音乐竞演、户外挑战、推理探案等全品类综艺内容。无需注册、无需下载，打开即看，高清流畅不缓冲，是您追综看综的最佳选择。当前热播《乘风2026》《披荆斩棘》《奔跑吧》《中餐厅》等头部综艺均已上线，完整版持续更新中。',
  stats: [
    { label: '每日更新', value: '50+ 期' },
    { label: '综艺覆盖', value: '300+ 档' },
    { label: '高清画质', value: '1080P' },
  ],
  ctaPrimary: { text: '立即观看', href: '#index' },
  ctaSecondary: { text: '了解平台', href: '#about' },
};

export const updatesData = [
  { date: '2026-07-31', title: '《乘风2026》第六期正片上线，姐姐们三公舞台炸裂全场', tag: '新上线' },
  { date: '2026-07-30', title: '《披荆斩棘》总决赛名单公布，哥哥们终极对决即将上演', tag: '热播中' },
  { date: '2026-07-29', title: '《中餐厅》第九季海南站开播，全新嘉宾阵容首度曝光', tag: '热播中' },
  { date: '2026-07-28', title: '《奔跑吧》特别篇"城市追击战"精彩回顾合集上线', tag: '专题' },
  { date: '2026-07-27', title: '2026下半年综艺片单公布，《声生不息》《密室大逃脱》续作回归', tag: '预告' },
  { date: '2026-07-26', title: '《心动的信号》第七季心动连线开启，素人嘉宾首亮相', tag: '新上线' },
  { date: '2026-07-25', title: '平台画质全面升级至1080P，观影体验全新提升', tag: '公告' },
];

export const carouselData = [
  {
    id: 'c1',
    title: '乘风2026',
    subtitle: '姐姐们的第三次公演',
    description: '三十位姐姐集结，用舞台重新定义自我。本季赛制全面升级，新增"跨界挑战"环节，姐姐们将挑战完全陌生的表演领域，精彩不容错过。',
    tag: '热播TOP1',
    image: 'https://readdy.ai/api/search-image?query=A%20glamorous%20stage%20performance%20with%20colorful%20lighting%20and%20dynamic%20dancers%20in%20elegant%20costumes%2C%20warm%20golden%20spotlights%2C%20entertainment%20show%20atmosphere%2C%20cinematic%20wide%20shot%2C%20professional%20stage%20photography%2C%20rich%20warm%20amber%20tones%20against%20dark%20background&width=640&height=400&seq=carousel-01&orientation=landscape',
  },
  {
    id: 'c2',
    title: '披荆斩棘',
    subtitle: '总决赛巅峰之夜',
    description: '二十四位哥哥历经层层淘汰，最终十二人挺进总决赛。谁能问鼎年度总冠军？终极舞台，一触即发。',
    tag: '即将收官',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20with%20intense%20spotlight%20and%20silhouette%20of%20performers%2C%20dark%20theater%20atmosphere%20with%20warm%20accent%20lighting%2C%20grand%20finale%20concert%20vibe%2C%20professional%20stage%20photography%2C%20cinematic%20composition%20with%20deep%20shadows%20and%20rich%20golden%20highlights&width=640&height=400&seq=carousel-02&orientation=landscape',
  },
  {
    id: 'c3',
    title: '中餐厅 第九季',
    subtitle: '海南岛美食之旅',
    description: '全新一季中餐厅落户海南三亚，五位合伙人将在海边经营一家融合当地特色的创意中餐厅，用美食连接每一位远道而来的客人。',
    tag: '新季开播',
    image: 'https://readdy.ai/api/search-image?query=Bright%20and%20airy%20seaside%20restaurant%20interior%20with%20wooden%20furniture%20and%20tropical%20plants%2C%20warm%20natural%20sunlight%20streaming%20through%20large%20windows%2C%20cozy%20dining%20atmosphere%2C%20culinary%20show%20setting%2C%20professional%20interior%20photography%20with%20soft%20golden%20hour%20lighting&width=640&height=400&seq=carousel-03&orientation=landscape',
  },
  {
    id: 'c4',
    title: '奔跑吧',
    subtitle: '城市追击战特辑',
    description: '跑男团空降六座城市，开启前所未有的城市追击战。解谜、竞速、反转，每一期都是全新的冒险体验。',
    tag: '特别企划',
    image: 'https://readdy.ai/api/search-image?query=Urban%20cityscape%20with%20dynamic%20motion%20blur%20effect%2C%20group%20of%20people%20running%20through%20modern%20city%20streets%2C%20bright%20daylight%20with%20vibrant%20colors%2C%20energetic%20and%20playful%20atmosphere%2C%20cinematic%20action%20photography%20with%20warm%20sunlight&width=640&height=400&seq=carousel-04&orientation=landscape',
  },
  {
    id: 'c5',
    title: '声生不息',
    subtitle: '港乐季 重磅回归',
    description: '殿堂级歌手与新生代唱将同台，重新演绎华语经典。跨越时代的音乐对话，每一首歌都是一段回忆。',
    tag: '即将播出',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20music%20studio%20with%20vintage%20microphones%20and%20warm%20lighting%2C%20classical%20meets%20modern%20music%20aesthetic%2C%20rich%20amber%20and%20gold%20tones%2C%20professional%20recording%20studio%20photography%2C%20nostalgic%20yet%20contemporary%20atmosphere%20with%20soft%20bokeh%20background&width=640&height=400&seq=carousel-05&orientation=landscape',
  },
  {
    id: 'c6',
    title: '密室大逃脱',
    subtitle: '第六季 全新密室',
    description: '全新密室主题设计，更烧脑的谜题，更刺激的逃脱体验。六位玩家能否在限定时间内成功逃脱？',
    tag: '即将回归',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dimly%20lit%20room%20with%20hidden%20clues%20and%20puzzle%20elements%2C%20escape%20room%20setting%20with%20warm%20accent%20lighting%20and%20shadows%2C%20immersive%20and%20atmospheric%2C%20professional%20set%20photography%2C%20rich%20amber%20and%20deep%20brown%20tones&width=640&height=400&seq=carousel-06&orientation=landscape',
  },
];

export const indexData = [
  {
    title: '音乐竞演',
    description: '《乘风2026》《披荆斩棘》《声生不息》等热门音乐综艺',
    icon: 'ri-music-2-line',
    count: '42 档',
  },
  {
    title: '户外真人秀',
    description: '《奔跑吧》《极限挑战》《向往的生活》等户外挑战节目',
    icon: 'ri-compass-3-line',
    count: '38 档',
  },
  {
    title: '推理探案',
    description: '《密室大逃脱》《明星大侦探》《开始推理吧》等烧脑综艺',
    icon: 'ri-search-eye-line',
    count: '25 档',
  },
  {
    title: '生活慢综',
    description: '《中餐厅》《五十公里桃花坞》《你好生活》等治愈系综艺',
    icon: 'ri-plant-line',
    count: '30 档',
  },
  {
    title: '恋爱观察',
    description: '《心动的信号》《半熟恋人》《我们恋爱吧》等情感综艺',
    icon: 'ri-heart-line',
    count: '20 档',
  },
  {
    title: '脱口秀',
    description: '《脱口秀大会》《吐槽大会》《今晚开放麦》等语言类节目',
    icon: 'ri-emotion-laugh-line',
    count: '18 档',
  },
  {
    title: '访谈文化',
    description: '《圆桌派》《十三邀》《锵锵行天下》等深度对话节目',
    icon: 'ri-chat-1-line',
    count: '22 档',
  },
];

export const topicsData = [
  { name: '乘风2026三公', count: '128万讨论' },
  { name: '披荆斩棘总决赛', count: '96万讨论' },
  { name: '中餐厅海南站', count: '73万讨论' },
  { name: '奔跑吧城市追击', count: '85万讨论' },
  { name: '心动的信号第七季', count: '61万讨论' },
  { name: '声生不息港乐季', count: '54万讨论' },
  { name: '密室大逃脱回归', count: '48万讨论' },
  { name: '综艺片单2026', count: '42万讨论' },
  { name: '高清综艺推荐', count: '37万讨论' },
];

export const rankingData = [
  { rank: 1, title: '乘风2026', tag: '音乐竞演', heat: '热度 9.8', trend: 'up' },
  { rank: 2, title: '披荆斩棘', tag: '音乐竞演', heat: '热度 9.6', trend: 'up' },
  { rank: 3, title: '奔跑吧', tag: '户外真人秀', heat: '热度 9.5', trend: 'stable' },
  { rank: 4, title: '中餐厅 第九季', tag: '生活慢综', heat: '热度 9.3', trend: 'up' },
  { rank: 5, title: '心动的信号 第七季', tag: '恋爱观察', heat: '热度 9.1', trend: 'up' },
  { rank: 6, title: '开始推理吧', tag: '推理探案', heat: '热度 8.9', trend: 'stable' },
  { rank: 7, title: '脱口秀大会', tag: '脱口秀', heat: '热度 8.7', trend: 'down' },
];

export const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '高清不缓冲',
    description: '全站1080P高清画质，智能CDN加速技术，保障流畅观影体验，看综艺再也不卡顿。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝切换',
    description: '支持电脑、平板、手机全平台观看，观影进度自动同步，随时随地继续追综。',
  },
  {
    icon: 'ri-download-cloud-line',
    title: '无需下载注册',
    description: '打开即看，无需安装任何软件或注册账号，综艺在线观看从未如此简单快捷。',
  },
  {
    icon: 'ri-timer-line',
    title: '日更不停歇',
    description: '每日同步更新50+期综艺内容，热门综艺第一时间上线，精彩绝不迟到。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告',
    description: '纯净观影环境，零弹窗、零强制广告，专注为您提供最佳的综艺观看体验。',
  },
];

export const appData = {
  title: '97在线影院 移动端',
  subtitle: '随时随地，综艺随心看',
  description: '打开手机浏览器访问97在线影院，即可获得与App一致的高清流畅观影体验。全站适配移动端，触屏操作流畅，画质自动适配网络环境，地铁、午休、睡前，追综时光不再受限。支持添加到手机桌面，一键直达您的专属综艺频道。',
  icon: 'ri-smartphone-line',
  features: ['高清自适应画质', '触屏手势操作', '进度自动同步', '桌面快捷入口'],
};

export const mediaData = [
  {
    title: '乘风2026 · 三公纯享版',
    description: '姐姐们三公舞台完整收录，六组对决全程高能，每一帧都燃到炸裂。',
    tag: '纯享版',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20stage%20performance%20with%20female%20dancers%20in%20sparkling%20costumes%2C%20dramatic%20lighting%20with%20warm%20golden%20and%20amber%20tones%2C%20concert%20photography%20style%2C%20high%20energy%20atmosphere%2C%20professional%20stage%20shot%20with%20shallow%20depth%20of%20field&width=640&height=400&seq=media-01&orientation=landscape',
  },
  {
    title: '披荆斩棘 · 总决赛预告',
    description: '十二位哥哥终极对决前瞻，总决赛赛制首次曝光，谁将问鼎巅峰？',
    tag: '预告片',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20silhouette%20with%20single%20performer%20under%20intense%20spotlight%2C%20dark%20theater%20atmosphere%2C%20grand%20finale%20anticipation%2C%20warm%20accent%20lighting%20against%20deep%20shadows%2C%20cinematic%20portrait%20photography%20with%20rich%20contrast&width=640&height=400&seq=media-02&orientation=landscape',
  },
  {
    title: '中餐厅 · 海南美食特辑',
    description: '合伙人首日营业全记录，从采购到下厨，海岛风味美食一网打尽。',
    tag: '精彩花絮',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20seaside%20kitchen%20with%20fresh%20ingredients%20and%20cooking%20utensils%2C%20warm%20natural%20afternoon%20light%2C%20tropical%20coastal%20vibe%2C%20culinary%20show%20behind%20the%20scenes%2C%20professional%20food%20photography%20with%20soft%20golden%20tones%20and%20ocean%20background&width=640&height=400&seq=media-03&orientation=landscape',
  },
  {
    title: '心动的信号 · 初见特辑',
    description: '七位素人嘉宾首次见面全记录，心动连线从这一刻开始变数丛生。',
    tag: '先导片',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20evening%20garden%20setting%20with%20fairy%20lights%20and%20candles%2C%20warm%20intimate%20atmosphere%2C%20soft%20bokeh%20background%20with%20twinkling%20lights%2C%20dating%20show%20aesthetic%2C%20professional%20photography%20with%20dreamy%20warm%20amber%20and%20rose%20tones&width=640&height=400&seq=media-04&orientation=landscape',
  },
];

export const cardsData = [
  {
    title: '《乘风2026》三公舞台全解析',
    description: '六组姐姐三公舞台深度复盘，从选曲到编舞，从舞美到表现力，一文看懂所有精彩看点与幕后故事。',
    tag: '深度解析',
    image: 'https://readdy.ai/api/search-image?query=Female%20performer%20on%20stage%20in%20elegant%20costume%20with%20dramatic%20lighting%2C%20professional%20stage%20photography%2C%20warm%20golden%20spotlights%2C%20performance%20art%20atmosphere%2C%20shallow%20depth%20of%20field%20with%20rich%20amber%20and%20coral%20tones&width=640&height=420&seq=card-01&orientation=landscape',
  },
  {
    title: '2026下半年必追综艺清单',
    description: '盘点下半年即将上线的20档重磅综艺，涵盖音乐、旅行、推理、美食全品类，追综日历一键收藏。',
    tag: '追综指南',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20collage%20style%20poster%20with%20entertainment%20show%20elements%2C%20warm%20and%20energetic%20color%20palette%2C%20creative%20typography%20layout%2C%20magazine%20cover%20aesthetic%2C%20professional%20graphic%20design%20with%20rich%20amber%20and%20coral%20accents%20on%20dark%20background&width=640&height=420&seq=card-02&orientation=landscape',
  },
  {
    title: '《奔跑吧》经典游戏大盘点',
    description: '从名牌大战到水上乐园，那些年跑男团玩过的经典游戏你还记得几个？一起来重温那些笑到肚子疼的名场面。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Outdoor%20game%20competition%20scene%20with%20colorful%20obstacles%20and%20water%20elements%2C%20bright%20sunny%20day%2C%20playful%20and%20energetic%20atmosphere%2C%20variety%20show%20game%20set%2C%20professional%20outdoor%20photography%20with%20vibrant%20warm%20colors&width=640&height=420&seq=card-03&orientation=landscape',
  },
  {
    title: '《中餐厅》招牌菜复刻指南',
    description: '跟着中餐厅合伙人学做菜，本期精选五道海南特色菜，从食材选购到烹饪技巧，在家也能做出餐厅级美味。',
    tag: '美食教程',
    image: 'https://readdy.ai/api/search-image?query=Gourmet%20Chinese%20dishes%20beautifully%20plated%20on%20wooden%20table%2C%20warm%20natural%20lighting%20from%20window%2C%20fresh%20ingredients%20and%20herbs%20scattered%20around%2C%20professional%20food%20photography%2C%20rich%20warm%20amber%20tones%20with%20shallow%20depth%20of%20field&width=640&height=420&seq=card-04&orientation=landscape',
  },
  {
    title: '密室逃脱综艺为什么越来越火',
    description: '从《密室大逃脱》到《开始推理吧》，推理类综艺为何能持续吸引观众？深度分析密室综艺的魅力密码。',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=Dimly%20lit%20mystery%20room%20with%20puzzle%20props%20and%20cryptic%20symbols%20on%20walls%2C%20atmospheric%20lighting%20with%20warm%20accent%20lamps%2C%20immersive%20escape%20room%20setting%2C%20professional%20set%20photography%2C%20rich%20dark%20amber%20and%20brown%20tones&width=640&height=420&seq=card-05&orientation=landscape',
  },
  {
    title: '从素人到明星：恋爱综艺进化史',
    description: '回顾国内恋爱综艺十年变迁，从《非诚勿扰》到《心动的信号》，看恋爱综艺如何一步步俘获观众的心。',
    tag: '综艺简史',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20evening%20setting%20with%20soft%20candlelight%20and%20flowers%2C%20elegant%20table%20for%20two%2C%20warm%20intimate%20atmosphere%2C%20dating%20show%20aesthetic%2C%20professional%20photography%20with%20dreamy%20rose%20and%20amber%20tones%2C%20shallow%20depth%20of%20field&width=640&height=420&seq=card-06&orientation=landscape',
  },
  {
    title: '《声生不息》港乐金曲重温',
    description: '那些年我们追过的港乐经典，《声生不息》舞台让这些金曲重获新生。盘点节目中最催泪的十个经典翻唱现场。',
    tag: '音乐特辑',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20vinyl%20records%20and%20retro%20microphone%20on%20wooden%20table%2C%20warm%20nostalgic%20lighting%2C%20music%20studio%20atmosphere%2C%20classic%20meets%20modern%20aesthetic%2C%20professional%20photography%20with%20rich%20golden%20and%20amber%20tones%2C%20soft%20shadows&width=640&height=420&seq=card-07&orientation=landscape',
  },
];

export const contactData = {
  title: '投稿与合作',
  description: '如果您有优质综艺资源推荐、内容合作意向或任何建议，欢迎通过以下方式联系我们。97在线影院期待与更多优质内容创作者携手，共同打造最全最优质的综艺观看平台。',
  email: 'contact@97cinema.com',
  wechat: '97cinema_official',
  hint: '商务合作 / 内容投稿 / 意见建议',
};

export const aboutData = {
  title: '关于97在线影院',
  description: '97在线影院是一个专注综艺节目在线观看的内容平台。我们致力于为用户提供最新、最全、最高清的综艺节目资源，涵盖音乐竞演、户外真人秀、推理探案、生活慢综、恋爱观察、脱口秀等全品类综艺内容。\n\n自上线以来，97在线影院始终坚持"无需下载、无需注册、高清不缓冲"的服务理念，每日同步更新50+期综艺内容，累计收录超过300档综艺节目。我们相信，好的综艺内容应该被更多人看到，好的观影体验不应该被广告和卡顿所打扰。\n\n未来，97在线影院将持续拓展内容品类，优化观影体验，努力成为华语地区最值得信赖的综艺在线观看平台。',
  stats: [
    { value: '300+', label: '综艺覆盖' },
    { value: '50+', label: '每日更新' },
    { value: '500万+', label: '月活用户' },
  ],
};

export const faqData = [
  {
    question: '97在线影院需要注册才能观看吗？',
    answer: '不需要。97在线影院坚持"无需下载、无需注册"的理念，所有综艺节目打开即可观看，没有任何门槛。',
  },
  {
    question: '综艺节目画质如何？观看会卡顿吗？',
    answer: '全站综艺均支持1080P高清画质，并采用智能CDN加速技术，根据您的网络环境自动适配最佳画质，保障流畅观影体验，正常网络下不会出现卡顿。',
  },
  {
    question: '综艺节目多久更新一次？',
    answer: '每日同步更新50+期综艺内容。热门综艺在电视台播出后24小时内即可在平台上线，确保您不错过任何精彩内容。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '97在线影院支持电脑、平板、手机全平台观看。网站采用响应式设计，自动适配不同屏幕尺寸，无论您使用什么设备，都能获得最佳的观影体验。',
  },
  {
    question: '可以下载综艺节目到本地吗？',
    answer: '97在线影院提供在线观看服务，目前暂不支持离线下载。您可以将网站添加到手机桌面，随时随地方便访问，在线观看同样流畅。',
  },
];

export const commentsData = [
  {
    name: '综艺迷小王',
    date: '2026-07-30',
    content: '追乘风2026第三季，每期都第一时间在97影院看！画质真的没话说，1080P看得太爽了，而且真的不卡顿，比某些要会员的平台还流畅。推荐给所有追综的朋友！',
    rating: 5,
  },
  {
    name: '追综达人Lucy',
    date: '2026-07-28',
    content: '之前一直在找能看完整版综艺的地方，终于发现了97在线影院。不用注册直接看太方便了，综艺资源也很全，新老综艺都有，已经安利给身边所有朋友！',
    rating: 5,
  },
  {
    name: '晚自习摸鱼生',
    date: '2026-07-25',
    content: '作为一个学生党，97影院简直是救星。不用下载App、不用充会员、没有广告打扰，中午吃饭看一集跑男，晚上睡前看一段脱口秀，非常惬意。希望平台越做越好！',
    rating: 5,
  },
  {
    name: '老牌综艺观众',
    date: '2026-07-22',
    content: '从《极限挑战》第一季就开始追的老观众了。97在线的综艺分类很清晰，找节目很方便。最近在补《开始推理吧》，推理综艺太上头了，一集接一集停不下来。',
    rating: 4,
  },
];

export const footerLinks = {
  sections: [
    {
      title: '综艺分类',
      links: ['音乐竞演', '户外真人秀', '推理探案', '生活慢综', '恋爱观察', '脱口秀'],
    },
    {
      title: '热门推荐',
      links: ['乘风2026', '披荆斩棘', '奔跑吧', '中餐厅', '心动的信号', '声生不息'],
    },
    {
      title: '快速入口',
      links: ['最新动态', '综艺排行', '移动观看', '常见问题', '关于我们'],
    },
  ],
  about: '97在线影院 — 热门综艺节目在线观看首选平台。每日更新50+期高清综艺，覆盖300+档热门节目，无需注册、无需下载，打开即看。最新综艺大全，免费高清不缓冲。',
};